'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$10() {
}
export { $c_Lpresto_CredentialTables$$anon$10 as $c_Lpresto_CredentialTables$$anon$10 };
$p = $c_Lpresto_CredentialTables$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$10;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$10() {
}
export { $h_Lpresto_CredentialTables$$anon$10 as $h_Lpresto_CredentialTables$$anon$10 };
$h_Lpresto_CredentialTables$$anon$10.prototype = $p;
$p.bh = (function(_$51) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$51, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$52) => _$52.D())), $j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().aea());
});
var $d_Lpresto_CredentialTables$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$10, "presto.CredentialTables$$anon$10", ({
  Ft: 1,
  H: 1
}));
export { $d_Lpresto_CredentialTables$$anon$10 as $d_Lpresto_CredentialTables$$anon$10 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$10.js.map
